import { CompanyRepository } from "core/repository";
import { Base2Presenter } from "core/presenter";

import UserConstraint from "core/constraint/user.constraint";
import validate from "util/validate";

class GeneralInfoPresenter extends Base2Presenter {
  initialState() {
    return {
      checkBoxUser: "",
      currentUser: {},
      relatedCompanies: [],
      companyList: {
        visible: false,
        filterValue: ""
      },
      errors: {
        name: "",
        username: "",
        company_uuid: ""
      },
      companySearchOptions: {
        online: true,
        repository: CompanyRepository,
        order: [{ field: "slug", direction: "ASC" }],
        pagination: { page: 1, perPage: 25 },
        filter: async filter => await this.getFilter(filter)
      },
      allowedCompanies: [],
      filterLoading: false,
      filter: ""
    };
  }

  async onStart() {
    const currentUser = await this.mRuntime.get("currentUser");
    this.enqueue({ currentUser });
    this.getAllowedCompanies();
  }

  async getFilter(filter) {
    const { form, mode } = this.props;
    const currentUser = await this.mRuntime.get("currentUser");

    const target = mode === "add" ? currentUser : form;
    const userAllowedCompanies = target.allowed_companies_uuids.map(uuid => ({
      connector: "OR",
      field: "uuid",
      operation: "EQ",
      value: uuid
    }));

    if (userAllowedCompanies.length === 0) {
      userAllowedCompanies.push({
        connector: "OR",
        field: "uuid",
        operation: "EQ",
        value: null
      });
    }

    return [
      ...userAllowedCompanies,
      { connector: "AND", field: "slug", operation: "LIKE", value: filter }
    ];
  }

  onSelectCompany(company) {
    const { form } = this.props;
    form.company = company || {};
    form.company_uuid = form.company.uuid;
  }

  doValidateField(value, field) {
    const constraint = UserConstraint.general;
    const validation = validate({ [field]: value }, constraint, {
      fullMessages: false
    });

    return validation;
  }

  async getAllowedCompanies() {
    this.enqueue({ filterLoading: true });
    const currentUser = await this.mRuntime.get("currentUser");

    const additionalCompanies = await (currentUser.is_admin
      ? this.getAllowedCompaniesForAdmin(currentUser)
      : []);

    const allowedUuidCompanies = await this.loadAdditionalUuidCompanies(
      additionalCompanies
    );

    const allAllowedCompanies = additionalCompanies.concat(
      allowedUuidCompanies
    );

    this.enqueue({
      allowedCompanies: allAllowedCompanies,
      filterLoading: false
    });
  }

  async getAllowedCompaniesForAdmin(currentUser, slug) {
    const filters = [
      {
        connector: "AND",
        field: "account_uuid",
        operation: "EQ",
        value: currentUser.company.account_uuid
      }
    ];

    if (slug) {
      filters.push({
        connector: "AND",
        field: "slug",
        operation: "LIKE",
        value: slug
      });
    }

    const companiesResult = await CompanyRepository.getAll({
      filters
    });

    if (companiesResult.success) {
      return companiesResult.data.map(c => ({
        account_uuid: c.account_uuid,
        uuid: c.uuid,
        slug: c.slug,
        cnpj: c.fiscal_informations.cnpj
      }));
    } else {
      return [];
    }
  }

  onChangeIsSalesMan(value) {
    const { form } = this.props;
    form.is_salesman = !value;
    this.enqueue({
      isSalesManProps: form.is_salesman
    });
  }

  onCheckCompany(uuid) {
    if (this.props.form.allowed_companies_uuids.includes(uuid)) {
      this.props.removeAllowedCompanyUuid(uuid);
    } else {
      this.props.addAllowedCompanyUuid(uuid);
    }
  }

  onFilterChange(value) {
    this.enqueue({ filter: value }, async () => {
      value.length
        ? await this.loadFilteredAvailableCompanies()
        : await this.getAllowedCompanies();
    });
  }

  async loadAdditionalUuidCompanies(additionalCompanies, filter) {
    const currentUser = await this.mRuntime.get("currentUser");

    const allowedCompanies$ = currentUser.allowed_companies_uuids.map(
      async uuid => {
        const hasCompanyAlready = !!additionalCompanies.find(
          c => c.uuid === uuid
        );

        if (hasCompanyAlready) {
          return {};
        }

        const result = await CompanyRepository.getOnline(uuid);

        if (!result.success) {
          return {};
        }

        const company = result.data;

        let parsedCompany = {
          account_uuid: company.account_uuid,
          uuid: company.uuid,
          slug: company.slug,
          cnpj: company.fiscal_informations.cnpj
        };

        if (filter) {
          parsedCompany = company.slug
            .toLowerCase()
            .includes(filter.toLowerCase())
            ? parsedCompany
            : {};
        }

        return parsedCompany;
      }
    );

    let allowedCompanies = await Promise.all(allowedCompanies$);

    return allowedCompanies.filter(c => Object.keys(c).length > 0);
  }

  async loadFilteredAvailableCompanies() {
    this.enqueue({ filterLoading: true });

    const name = this.viewModel.filter;
    const currentUser = await this.mRuntime.get("currentUser");

    const additionalCompanies = await (currentUser.is_admin
      ? this.getAllowedCompaniesForAdmin(currentUser, name)
      : []);

    const allowedUuidCompanies = await this.loadAdditionalUuidCompanies(
      additionalCompanies,
      name
    );

    const allAllowedCompanies = additionalCompanies.concat(
      allowedUuidCompanies
    );

    this.enqueue({
      allowedCompanies: allAllowedCompanies,
      filterLoading: false
    });
  }
}

export default GeneralInfoPresenter;



// WEBPACK FOOTER //
// ./src/components/app/registration/user/form/general-info/general-info.presenter.js